import axiosInstance from "./api";

const FRAGMENTS_API = "/api/prompt_fragments";

const processResponse = (result, defaultValue = null) => {
  return result.data?.data || defaultValue;
};

const promptFragmentsService = {
  async createFragment({ block_name, description, name }) {
    const result = await axiosInstance.post(`${FRAGMENTS_API}`, {
      block_name,
      description,
      name,
    });
    return processResponse(result, []);
  },

  async getFragmentById(id) {
    const result = await axiosInstance.get(`${FRAGMENTS_API}/${id}`);
    return processResponse(result, []);
  },

  async getFragments() {
    const result = await axiosInstance.get(`${FRAGMENTS_API}`);
    return processResponse(result, []);
  },

  async updateFragment({
    id,
    defaultFlag,
    deleted,
    description,
    fragmentName,
  }) {
    const result = await axiosInstance.put(`${FRAGMENTS_API}/${id}`, {
      default: defaultFlag,
      deleted,
      description,
      name: fragmentName,
    });
    if (result.status !== 200 && result.status !== 201) {
      throw new Error(result.data?.error || "Failed to update fragment");
    }
    return result.data?.data?.entries || [];
  },

  async deleteFragment(id) {
    const fragment = await this.getFragmentById(id);
    if (!fragment) {
      throw new Error(`Prompt with id ${id} not found`);
    }
    const result = await axiosInstance.delete(`${FRAGMENTS_API}/${id}`);
    return processResponse(result, []);
  },

  async getFragmentVersionsById(id) {
    const result = await axiosInstance.get(`${FRAGMENTS_API}/${id}/versions`);
    return processResponse(result, []);
  },

  async getLatestFragmentVersion(id) {
    const result = await axiosInstance.get(`${FRAGMENTS_API}/${id}/latest`);
    return processResponse(result, []);
  },

  async getPromptFragmentVersion(fragment_id, version) {
    const result = await axiosInstance.get(
      `${FRAGMENTS_API}/${fragment_id}/versions/${version}`
    );
    return processResponse(result, []);
  },

  async createFragmentVersion({ fragment_id, content }) {
    const result = await axiosInstance.post(
      `${FRAGMENTS_API}/${fragment_id}/versions`,
      {
        content,
      }
    );
    if (result.status !== 200 && result.status !== 201) {
      throw new Error(
        result.data?.error || "Failed to create fragment version"
      );
    }
    return processResponse(result, []);
  },

  async exportFragment({ fragmentId, version = null }) {
    const versionQuery = version ? `?version=${version}` : "";
    const result = await axiosInstance.get(
      `${FRAGMENTS_API}/export/${fragmentId}${versionQuery}`
    );
    if (result.status !== 200 && result.status !== 201) {
      console.error("There was an error exporting the fragment.");
      throw new Error("There was an error exporting the fragment.");
    }
    return result.data?.data || { file_name: null, file_content: null };
  },

  async importFragment({
    prompt_fragment,
    prompt_fragment_version,
    forced = false,
  }) {
    const forcedQuery = forced ? `?forced=true` : "";
    const result = await axiosInstance.post(
      `${FRAGMENTS_API}/import${forcedQuery}`,
      {
        prompt_fragment,
        prompt_fragment_version,
      }
    );
    if (
      result.status !== 200 &&
      result.status !== 201 &&
      result.status !== 204
    ) {
      console.error("There was an error importing the fragment.");
      throw new Error("There was an error importing the fragment.");
    }
    return result.data?.data || { imported_fragments: [] };
  },
};

export default promptFragmentsService;
